'use client'
import { createContext, useContext } from 'react'
import { BookingContextValue } from './bookingTypes'

export const BookingContext = createContext<BookingContextValue | undefined>(undefined)

export function useBooking() {
  const context = useContext(BookingContext)
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider')
  }
  return context
}
